// Values are matching the severities in the API.
export var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel["Info"] = "INFO";
    SeverityLevel["Low"] = "LOW";
    SeverityLevel["Medium"] = "MEDIUM";
    SeverityLevel["High"] = "HIGH";
    SeverityLevel["Severe"] = "SEVERE";
})(SeverityLevel || (SeverityLevel = {}));
export var SeverityTagTestSubjects;
(function (SeverityTagTestSubjects) {
    SeverityTagTestSubjects["SeverityTag"] = "severity-tag";
})(SeverityTagTestSubjects || (SeverityTagTestSubjects = {}));
//# sourceMappingURL=severity-level.enum.js.map